// src/components/common/TextInput.jsx
import React, { forwardRef } from "react";

/**
 * TextInput
 * Props: label, id, value, onChange, placeholder, type, error, icon
 */
const TextInput = forwardRef(
  (
    {
      label,
      id,
      value,
      onChange,
      placeholder,
      type = "text",
      error,
      icon,
      containerStyle,
      ...rest
    },
    ref
  ) => {
    return (
      <div style={containerStyle ?? { marginBottom: 12 }}>
        {label && (
          <label
            htmlFor={id}
            className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            {label.replace(' *', '')}
            {label.includes('*') && <span className="text-red-500 ml-1">*</span>}
          </label>
        )}
        <div className="relative">
          {icon && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 dark:text-gray-500">
              {icon}
            </div>
          )}
          <input
            id={id}
            ref={ref}
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={`input-field dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:placeholder-gray-500 ${
              icon ? "!pl-12" : ""
            }`}
            {...rest}
          />
        </div>
        {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
      </div>
    );
  }
);

TextInput.displayName = "TextInput";

export default TextInput;
